<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <GoBack />
            <h3 class="d-inline heading">{{ tasklist_name }}</h3>
          </div>
          <div class="heading-seperator"></div>

          <div class="col-md-6 col-sm-9 col-12 mx-auto" style="font-size: 18px;" v-if="students.length > 0">
            <label class="text-align-center">Students: </label>
            <b-form-select v-model="student_id" :options="students" style="margin-bottom: 0px !important" class="mb-3 col-md-12"  @change="updateStudentTasklistAction()" />
            <hr style="width:100%;">
          </div>
          <div v-show="page_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

          <div class="row" v-show="no_students">
            <div class="mx-auto">
              <h6 class="text-align-center">No Students assigned for this tasklist.</h6>
            </div>
          </div>

          <div class="col-md-12 counter_subtask-list" id="tasks">
            <div v-for = "(subtask, stindex) in subtasks">
              <div class="subtask-wrapper">
                <h4 class="panel-title">
                  <b-link v-b-toggle="'collapse-' + subtask.id">
                    <span class="counter_subtask-list__counter"></span>
                    {{ subtask.name }}
                  </b-link>
                </h4>
                <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper">
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(heading, index) in subtask.headings">
                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id" size="sm" class="sub-heading">
                          <span class="counter_heading-list__counter"></span>
                          {{ heading.name }}
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                          <div class="col-md-12 override-padding counter_task-list">
                            <div v-for = "task in heading.tasks">
                              <b-card @click="openHistoryModal('' + student_id + '', '' + task.id + '')" class="float-left d-none d-md-block d-lg-block modal-task">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                <div class="other-account-task-score" v-bind:id="'popover-target-' + subtask.id + '-' + task.id" v-if="task.instructor_score">
                                  {{ task.instructor_score }}
                                  <b-popover v-bind:target="'popover-target-' + subtask.id + '-' + task.id" triggers="hover" placement="top">
                                    <template v-slot:title>Mentor Comments</template>
                                    {{ task.instructor_comment }}
                                  </b-popover>
                                </div>
                                <div class="task-score" data-toggle="tooltip" title="Score" v-if="task.score">
                                  {{ task.score }}
                                </div>
                              </b-card>

                              <b-card v-bind:id="task.id" class="float-left  d-block d-sm-block d-md-none">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                <div class="other-account-task-score" v-bind:id="'popover-target-mob-' + subtask.id + '-' + task.id" v-if="task.instructor_score">
                                  {{ task.instructor_score }}
                                  <b-popover v-bind:target="'popover-target-mob-' + subtask.id + '-' + task.id" triggers="hover" placement="top">
                                    <template v-slot:title>Mentor Comments</template>
                                    {{ task.instructor_comment }}
                                  </b-popover>
                                </div>
                                <div class="task-score" v-if="task.score">
                                  {{ task.score }}
                                </div>
                                <div class="comment-icon-wrapper">
                                  <router-link v-bind:to="'/student-add-task-assessment/' + student_id + '/' + group_id + '/' + task.id + '/' + tasklist_id + '@' + heading.id + '@' + subtask.id + ''">
                                    <i class="fa fa-comment"></i><span class="view-comment">Add Comments</span>
                                  </router-link>
                                </div>
                              </b-card>
                            </div>
                          </div>
                          <div style="clear: both;"></div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for = "substasklisttask in subtask.tasks" class="task-wrapper">
                        <b-card @click="openHistoryModal('' + student_id + '', '' + substasklisttask.id + '')" class="float-left d-none d-md-block modal-task">
                          <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ substasklisttask.description }}
                          </div>
                          <div class="other-account-task-score" v-bind:id="'popover-target-' + substasklisttask.id"
                          v-if="substasklisttask.instructor_score">
                            {{ substasklisttask.instructor_score }}
                            <b-popover v-bind:target="'popover-target-' + substasklisttask.id" triggers="hover" placement="top">
                              <template v-slot:title>Mentor Comments</template>
                              {{ substasklisttask.instructor_comment }}
                            </b-popover>
                          </div>
                          <div class="task-score" data-toggle="tooltip" title="Score" v-if="substasklisttask.score">
                            {{ substasklisttask.score }}
                          </div>
                        </b-card>

                        <b-card v-bind:id="substasklisttask.id" class="float-left d-block d-sm-block d-md-none">
                          <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ substasklisttask.description }}
                          </div>
                          <div class="other-account-task-score" v-if="substasklisttask.instructor_score"
                              v-bind:id="'popover-target-mob-' + substasklisttask.id">
                            {{ substasklisttask.instructor_score }}
                            <b-popover v-bind:target="'popover-target-mob-' + substasklisttask.id" triggers="hover" placement="top">
                              <template v-slot:title>Mentor Comments</template>
                              {{ substasklisttask.instructor_comment }}
                            </b-popover>
                          </div>
                          <div class="task-score" v-if="substasklisttask.score">
                            {{ substasklisttask.score }}
                          </div>
                          <div class="comment-icon-wrapper">
                            <router-link v-bind:to="'/student-add-task-assessment/' + student_id + '/' + group_id + '/' + substasklisttask.id + '/' + tasklist_id + '@' + 'null' + '@' + subtask.id + ''">
                              <i class="fa fa-comment"></i><span class="view-comment">Add Comments</span>
                            </router-link>
                          </div>
                        </b-card>

                      </div>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>
              </div>
            </div>


           <custommodal :isModalVisible="isModalVisible" @close="isModalVisible = false">
               <span v-if="loading" class="pull-right text-danger">
                    Loading...
               </span>
               <div slot="header" class="sub-heading">{{history_title}}</div>

               <div slot="body">
                <div class="comment_form">
                  <input v-model="hmentee_id" type="hidden" name="hmentee_id" id="hmentee_id">
                  <input v-model="htask_id" type="hidden" name="htask_id" id="htask_id">
                  <div class="label">Score:</div>
                  <b-form-select
                   class="input-text"
                   v-model="score_selected"
                   :options="score_options"
                  >
                  </b-form-select>                  <div style="clear: both" class="margin-bottom-20"></div>
                  <div class="label">Comments:</div>
                  <textarea
                    v-model="comments"
                    placeholder="Add your comments"
                    class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25"
                    maxlength="1000"
                    >
                  </textarea>
                  <div style="clear: both" class="margin-bottom-20"></div>
                  <div class="submit margin-bottom-15">
                    <button type="submit" @click="onSubmit" class="submit_button btn btn-info btn-md">Submit</button>
                    <button type="submit" @click="closeModal" class="margin-left-20 submit_button btn btn-grey btn-md">Cancel</button>
                  </div>
                  <div style="clear: both"></div>
                  </div>
                 <div class="history-table-wrapper">
                 <table class="generic-list">
                   <thead>
                   <tr>
                       <th class="date">DATE</th>
                       <th class="score">SCORE</th>
                       <th class="comment">COMMENT</th>
                       <th class="postedby">COMMENTED BY</th>
                   </tr>
                   </thead>
                   <div v-show="assessment_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                   <template v-for = "history in history_comment">
                    <tr>
                      <td>{{history.createdAt | formatDate}}</td>
                      <td>{{history.score}}</td>
                      <td>{{history.comment}}</td>
                      <td>{{history.mentor_name}}</td>
                    </tr>
                  </template>
                  <template v-if="history_comment.length == 0 && assessment_loading == false">
                    <tr >
                      <td colspan="4">No Assessments Found.</td>
                    </tr>
                 </template>
                </table>
              </div>
              </div>
            </custommodal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import custommodal from '../manager/custom_modal.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store.js';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
        data() {
          return {
            'subtasks': [],
            'tasklist_id': '',
            'tasklist_name': '',
            'students': [],
            'student_id': '',
            'isModalVisible': false,
            'history_title': '',
            'history_comment': '',
            'loading': false,
            'score_selected': 1,
            'comments': '',
            'haccount_id': '',
            'hmentee_id': '',
            'htask_id': '',
            'open': true,
            'close': false,
            'page_loading': false,
            'group_id': '',
            'no_students': false,
            'assessment_loading': false,
            'score_options': [],
            }
        },
        components: {
          UserMenu,
          GoBack,
          custommodal
        },
        methods: {
          onSubmit() {
            axios.post('/assessment', {
              score: this.score_selected,
              comment: this.comments,
              mentee_id: this.hmentee_id,
              task_id: this.htask_id,
              tasklist_id: this.tasklist_id,
            })
            .then(response =>  {
              this.showTasks(this.hmentee_id, this.tasklist_id);
              this.isModalVisible = false;
            })
          },
          closeModal() {
            this.isModalVisible = false;
            this.$emit('close');
          },
          updateStudentTasklistAction: function() {
            this.loading = true;
            this.subtasks = [];
            this.tasklist_name = '';
            this.showTasks(this.student_id, this.tasklist_id);
          },
          showTasks(student, taskListId) {
             axios.get('/desktop/mentees_tasklists_detail/' + student + '/' + taskListId + '/' + this.$store.state.user_accountid, {

             })
             .then(response =>  {
                this.page_loading = false;
                this.subtasks = response.data.subtasks;
                this.tasklist_name = response.data.title
             })
             .catch(function(error) {

             });
           },
           getScoreLists() {
              axios.get('/score-lists', {

              })
              .then(response =>  {
                 this.score_options = response.data;
              })
              .catch(function(error) {

              });
            },
           getStudentLists() {
              axios.get('/studentslist', {
                params: {
                  group_id: this.group_id,
                  tasklist_id: this.tasklist_id
                }
              })
              .then(response =>  {
                  this.students = response.data;
                  if(this.$route.query.e4) {
                    this.student_id = this.$route.query.e4;
                  }
                  else if(this.students.length > 0) {
                    this.student_id = this.students[0].value;
                  }
                  else if(this.students.length == 0){
                    this.no_students = true;
                    this.page_loading = false;
                  }
                  if(this.student_id > 0) {
                    this.showTasks(this.student_id, this.tasklist_id)
                  }

              })
              .catch(function(error) {

              });
            },
           openHistoryModal(student, taskId) {
             this.comments = '';
             this.score_selected = 1;
             this.isModalVisible = true;
             this.assessment_loading = true;
             this.loading = true;
             this.history_title = '';
             this.history_comment = '';
             axios.get('/assessment', {
               params: {
                 mentee_id: student,
                 task_id: taskId,
                 tasklist_id: this.tasklist_id,
               }
             })
             .then(response =>  {
                this.loading = false;
                this.assessment_loading = false;
                this.hmentee_id = student;
                this.htask_id = taskId;
                this.history_title = response.data.task.description;
                this.history_comment = response.data.history;
             })
             .catch(function(error) {

             });
           },
        },
        created: function () {
          this.page_loading = true;
          this.tasklist_id = this.$route.params.tasklist_id;
          this.group_id = this.$route.params.group_id;
          this.getStudentLists();
          this.getScoreLists();
        },
        updated() {
          setTimeout(()=>{
            var e1_val = this.$route.query.e1;
            var e2_val = this.$route.query.e2;
            var e3_val = this.$route.query.e3;
            if(e1_val) {

                var ele2 = document.getElementById("collapse-" + e1_val).parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
                ele2.className = '';
                document.getElementById("collapse-" + e1_val).parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0].setAttribute("aria-expanded", true);
                document.getElementById("collapse-" + e1_val).style.display = "block";
                if(e2_val > 0) {
                  var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
                  ele1.style.display = 'block';
                }
                document.getElementById(e3_val).scrollIntoView(false);
            }
          }, 500);
        },
    }



</script>

<style scoped>

.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
    font-size: 20px;
    margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
  .task-item-list {
    margin-top: 5px;
  }
  #tasks {
      margin-top: 5px;
  }
  label {
    width: 100%;
    font-size: 15px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/instructor/students_tasks_details.vue